import React from 'react'

import CreateJoinUrlButton from './CreateJoinUrlButton'
import OpenButton from './OpenButton'

const JoinRoomButton = props => {
  const {
    joinUrl, // via withState
    onClickJoinRoom, // via withMutation
    liveNow, // via RoomCardContainer/withState
    loading, // via withMutation
    variant, // via parent
    size, // via parent
    color // via parent
  } = props

  const disabled = !liveNow

  // if we have a joinUrl, link to it
  if (joinUrl) {
    return (
      <OpenButton
        disabled={disabled}
        joinUrl={joinUrl}
        variant={variant}
        size={size}
        color={color}
      >
        Click to Open!
      </OpenButton>
    )
  }

  // otherwise, fetch the joinUrl via mutation
  return (
    <CreateJoinUrlButton
      onClickJoinRoom={onClickJoinRoom}
      loading={loading}
      disabled={disabled}
      variant={variant}
      size={size}
      color={color}
    />
  )
}

export default JoinRoomButton
